export default __webpack_public_path__ + "static/media/SEA_8698.6d69b79b.jpg";